import React from "react";
import { Link } from "react-router-dom";
import { CiCircleChevRight } from "react-icons/ci";

const Banner = () => {
  return (
    <div className="banner-wrapper">
      <div className="banner-overlay">
        <div className="container banner-content">
           <div className="banner-mobile-img">
             <img src="/bigheroimgph.png" alt="hero" />
           </div>
          <div className="banner-left">
            <h1 className="banner-title">
              Your nine-month journey,
              <br />
              beautifully held.
            </h1>

            <p className="banner-desc">
              The choices you make today shape a lifetime. Don’t navigate them
              alone in a fragmented system. At Myprega, we surround you with a
              dedicated circle of 9 medical experts and tech-driven care—
              transforming your pregnancy into a guided, healthy celebration.
            </p>

            <div className="banner-btns">
              <Link to="/cherish-care" className="btn-primary">
                <CiCircleChevRight />
                Start Your Journey With Us
              </Link>

              <Link to="/AIDashboardV3" className="btn-dark">
                Experience our AI
              </Link>
            </div>

            <div className="banner-hindi-note">
              <img src="/awroR.png" className="banner-hindi-arrow" alt="" />
              <span className="banner-hindi-text">"सिर्फ एक सफ़र नहीं, एक खूबसूरत उत्सव"</span>
            </div>
          </div>
          <div className="banner-right"></div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
